import { Reveal } from "@/components/Reveal";

const CLIENTS = [
  { name: "FIAT Automobile", note: "Market assessment" },
  { name: "European SMEs", note: "Acquisition funnels" },
  { name: "Tech Distributors", note: "Pipeline growth" },
];

const PLATFORMS = ["Salesforce", "Google Ads", "Meta Ads", "LinkedIn Ads", "HubSpot", "GA4"];

export default function TrustStrip() {
  return (
    <section className="mx-auto max-w-[1440px] px-6 pt-10 pb-4 md:px-10" data-testid="trust-strip">
      <Reveal>
        <div className="grid gap-8 rounded-2xl border hairline bg-surface/70 p-6 md:grid-cols-[auto_1fr] md:items-center md:gap-12 md:p-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500 md:max-w-[140px] md:leading-relaxed">
            Trusted by &amp; built on
          </p>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <ul className="flex flex-wrap items-center gap-x-10 gap-y-4" data-testid="trust-clients">
              {CLIENTS.map((c) => (
                <li key={c.name} className="group" data-testid={`trust-client-${c.name.toLowerCase().replace(/\s+/g, "-")}`}>
                  <p className="font-display text-xl font-extrabold tracking-tight text-ink/80 transition-colors group-hover:text-ink md:text-2xl">
                    {c.name}
                  </p>
                  <p className="mt-0.5 font-mono text-[9px] uppercase tracking-[0.2em] text-neon/80">{c.note}</p>
                </li>
              ))}
            </ul>
            <div className="h-px w-full bg-slate-200 lg:h-10 lg:w-px" />
            <ul className="flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="trust-platforms">
              {PLATFORMS.map((p) => (
                <li key={p} className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500 transition-colors hover:text-ink">
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
